<template>
	<div class="more_menu_wrap-desktop">
		<div class="more_menu-desktop">
			<div class="more_menu_title-desktop">
				<h2 class="title_txt">더 보기</h2>
				<button type="button" class="title_btn" @click="closeMenuModal">
					<img src="@/assets/img/common/clear.svg" alt="close" loading="lazy" />
				</button>
			</div>
			<div class="menu_list">
				<ListLayout>
					<UserCard @close="onToggleMoreMenu" />
					<MenuGridBox @close="onToggleMoreMenu" />
				</ListLayout>
				<MoreMainMenuList @close="onToggleMoreMenu" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
// img
import { onUnmounted } from 'vue';

import MenuGridBox from '@/components/layout/header/MoreMenu/MenuGridBox.vue';
import UserCard from '@/components/layout/header/MoreMenu/UserCard.vue';
import { closeMenuModal } from '@/utils/function/modalMenu';

import ListLayout from '../../main/ListLayout.vue';

import MoreMainMenuList from './MoreMainMenuList.vue';

// -----variable-----

// -----function-----
// 더보기 토글 함수
const onToggleMoreMenu = () => {
	document.body.classList.remove('hidden');
};
// 화면 나갔을 경우, 스크롤 방지 기능 삭제
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.more_menu_wrap-desktop {
	position: absolute;
	top: 7rem;
	right: -7rem;
}
.more_menu-desktop {
	z-index: 80;
	width: 37.5rem;
	background-color: var(--color-bg);
	border-radius: var(--border-radius-small);
	box-shadow: 4px 4px 10px 0px #0000004d;
	padding: 0rem 2rem;
	.menu_list {
		height: 80dvh;
		overflow-y: scroll;
		-ms-overflow-style: none; /* 인터넷 익스플로러 */
		scrollbar-width: none; /* 파이어폭스 */
		padding-top: 1.6rem;
	}
	.more_menu_title-desktop {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: var(--font-s-large);
		font-weight: var(--font-w-bold);
		gap: var(--space-xx-small);
		padding: 1.85rem 0rem;
		line-height: 2.5rem;
		.title_btn {
			img {
				width: 2.4rem;
				height: 2.4rem;
			}
		}
	}
}
</style>
